import {RecognitionFeed} from "@irati/types"
import React from "react"
import ScheduledGroupCelebration from "./ScheduledGroupCelebration"

interface Props {
  item: RecognitionFeed
}
const GroupCelebrationFeedCard: React.FC<Props> = (props) => {
  const {
    item: {groupCelebration},
    ...otherProps
  } = props
  if (!groupCelebration) {
    return null
  }
  return <ScheduledGroupCelebration groupCelebration={groupCelebration} {...otherProps} />
}

export default GroupCelebrationFeedCard
